import { useState } from "react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { useDiscount } from "../contexts/DiscountContext";
import { Tag, Check, X } from "lucide-react";

const DiscountCodeInput = ({ plan, onApply }) => {
  const { validateCode } = useDiscount();
  const [code, setCode] = useState("");
  const [applied, setApplied] = useState(null);
  const [error, setError] = useState("");

  const handleApply = () => {
    if (!code.trim()) return;
    const result = validateCode(code, plan);
    if (result) {
      setApplied(result);
      setError("");
      onApply(result);
    } else {
      setError("Invalid or expired discount code");
      setApplied(null);
      onApply(null);
    }
  };

  const handleRemove = () => {
    setApplied(null);
    setCode("");
    setError("");
    onApply(null);
  };

  if (applied) {
    return (
      <div className="rounded-lg border border-green-500/30 bg-green-500/10 p-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Check className="h-4 w-4 text-green-400" />
          <span className="text-sm text-white font-medium">{applied.code}</span>
          <Badge className="text-[10px] bg-green-500/20 text-green-300 border-green-500/30">
            {applied.percentage}% off
          </Badge>
        </div>
        <button
          onClick={handleRemove}
          className="text-white/50 hover:text-white transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-2">
        <div className="relative flex-1">
          <Tag className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-white/30" />
          <Input
            placeholder="Enter discount code"
            value={code}
            onChange={(e) => {
              setCode(e.target.value.toUpperCase());
              setError("");
            }}
            onKeyDown={(e) => e.key === "Enter" && handleApply()}
            className="pl-9 bg-white/5 border-white/10 text-white placeholder:text-white/30 text-sm h-9"
          />
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={handleApply}
          disabled={!code.trim()}
          className="border-white/10 text-white hover:bg-white/10 text-xs h-9"
        >
          Apply
        </Button>
      </div>
      {error && <p className="text-xs text-red-400">{error}</p>}
    </div>
  );
};

export default DiscountCodeInput;
